import SearchDomainSelectorPresentation from 'components/SearchDomainSelector/SearchDomainSelectorPresentation'

export default {
  Presentation: SearchDomainSelectorPresentation,
}
